import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from "../../../auth/auth.service";
import { Observable } from "rxjs";
import { IAuthUser } from "../../../auth/types/auth.interface";

@Component({
    selector: 'greeting',
    templateUrl: './greeting.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GreetingComponent {

  user$: Observable<IAuthUser | null>;

  constructor() {
    const authService = inject(AuthService);

    this.user$ = authService.user$;
  }

}
